"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _DateControl = _interopRequireDefault(require("./DateControl"));
var _pickers = require("@material-ui/pickers");
var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));
var _styles = require("@material-ui/core/styles");
var _FilterControl = _interopRequireDefault(require("./FilterControl"));
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    facetWrapper: (0, _defineProperty2.default)({
      paddingBottom: theme.spacing(4.5)
    }, theme.breakpoints.up('md'), {
      marginRight: theme.spacing(10),
      paddingBottom: 0
    }),
    dateControlWrapper: (0, _defineProperty2.default)({
      paddingBottom: theme.spacing(4)
    }, theme.breakpoints.up('md'), {
      marginRight: theme.spacing(10),
      paddingBottom: 0
    }),
    filterControl: {
      fontSize: theme.typography.pxToRem(20)
    },
    filtersWrapper: {
      paddingRight: theme.spacing(4)
    }
  };
});
var Filters = function Filters(_ref) {
  var handleDateRangeFacetChange = _ref.handleDateRangeFacetChange,
    handleCheckboxFacetChange = _ref.handleCheckboxFacetChange,
    handleCheckboxFacetChangeAll = _ref.handleCheckboxFacetChangeAll,
    checkboxFacets = _ref.checkboxFacets,
    dateRangeFacet = _ref.dateRangeFacet,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'MMM d, YYYY' : _ref$dateFormat,
    datePickerProps = _ref.datePickerProps,
    facetState = _ref.facetState,
    uncheckallText = _ref.uncheckallText,
    _ref$invalidDateMessa = _ref.invalidDateMessage,
    invalidDateMessage = _ref$invalidDateMessa === void 0 ? 'Enter valid date' : _ref$invalidDateMessa,
    _ref$maxDateMessage = _ref.maxDateMessage,
    maxDateMessage = _ref$maxDateMessage === void 0 ? 'Start Date should be before End Date' : _ref$maxDateMessage,
    _ref$minDateMessage = _ref.minDateMessage,
    minDateMessage = _ref$minDateMessage === void 0 ? 'End Date should be after Start Date' : _ref$minDateMessage;
  var classes = useStyles();
  var datePickerMask = {
    rifmFormatter: function rifmFormatter(val) {
      return val.replace(/[^. ,[a-zA-Z0-9_]*$]+/gi, '');
    },
    refuse: /[^. ,[a-zA-Z0-9_]*$]+/gi,
    invalidDateMessage: invalidDateMessage
  };
  var startDatePickerProps = _objectSpread(_objectSpread({
    maxDateMessage: maxDateMessage
  }, datePickerMask), datePickerProps);
  if (facetState.dateRange.end) startDatePickerProps.maxDate = facetState.dateRange.end;
  var endDatePickerProps = _objectSpread(_objectSpread({
    minDateMessage: minDateMessage
  }, datePickerMask), datePickerProps);
  if (facetState.dateRange.start) endDatePickerProps.minDate = facetState.dateRange.start;
  return __jsx("div", {
    className: classes.filtersWrapper
  }, __jsx("div", {
    className: classes.dateControlWrapper
  }, __jsx(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns.default
  }, dateRangeFacet && __jsx(_react.default.Fragment, null, __jsx(_DateControl.default, {
    dateFormat: dateFormat,
    datePickerProps: startDatePickerProps,
    state: facetState.dateRange.start,
    onChange: handleDateRangeFacetChange('start'),
    label: dateRangeFacet.start.label,
    placeholder: dateRangeFacet.start.placeholder
  }), __jsx(_DateControl.default, {
    dateFormat: dateFormat,
    datePickerProps: endDatePickerProps,
    state: facetState.dateRange.end,
    onChange: handleDateRangeFacetChange('end'),
    label: dateRangeFacet.end.label,
    placeholder: dateRangeFacet.end.placeholder
  })))), checkboxFacets && checkboxFacets.map(function (facet, index) {
    return __jsx("div", {
      key: "checkbox-facets-".concat(index),
      className: classes.facetWrapper
    }, __jsx(_FilterControl.default, {
      state: facetState.checkbox[facet.itemKey],
      label: facet.label,
      onChange: handleCheckboxFacetChange(facet.itemKey),
      onChangeAll: facet.checkAllControl && handleCheckboxFacetChangeAll(facet.itemKey),
      uncheckallText: uncheckallText
    }));
  }));
};
var _default = Filters;
exports.default = _default;